import React from 'react'
import styles from './ButtonIcon.module.sass'
import { cn } from '@utils/safeTs'
import Link from 'next/link'
import { Loading } from '..'


interface Props {
  icon: React.ReactNode
  ariaLabel: string
  ariaExpanded?: boolean
  variant?: 'primary' | 'secondary' | 'ghost'
  colorVariant?: 'accent' | 'black' | 'danger'
  size?: 'xs' | 'sm' | 'md' | 'lg'
  type?: 'submit' | 'reset' | 'button'
  disabled?: boolean
  loading?: boolean
  href?: string
  newPage?: boolean
  download?: boolean
  onClick?: (e: React.MouseEvent<HTMLButtonElement | HTMLAnchorElement>) => void
  className?: string
}

const ButtonIcon = (props: Props) => {

  const { 
    icon,
    ariaLabel,
    ariaExpanded,
    variant = 'primary',
    colorVariant = 'accent', 
    size = 'md',
    type = 'button',
    disabled = false,
    loading = false,
    href,
    newPage = false,
    download = false,
    onClick,
    className = '',
  } = props

  const classNames = cn(styles.root, styles[`root--${variant}`], styles[`root--${colorVariant}`], styles[`root--${size}`], loading ? styles['root--loading'] : '', className)

  return href ? (
    <Link href={href} aria-label={ariaLabel} target={newPage ? '_blank' : undefined} download={download} onClick={onClick} className={classNames}>
      {loading ? <Loading /> : icon}
    </Link>
  ) : (
    <button 
      type={type} 
      disabled={disabled}
      aria-label={ariaLabel}
      aria-expanded={ariaExpanded}
      onClick={onClick}
      className={classNames}
    >
      {loading ? <Loading /> : icon}
    </button>
  )
}

export default ButtonIcon
